// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { Resources } from '@shared/localizations/Resources';
import { ChartDataType, TerceraChartDrawingType, ChartHistoryType } from './Utils/ChartConstants';
import { TerceraChartActionState } from './TerceraChartActionState';
import { TerceraChartUtils, TerceraChartHistoryType } from './TerceraChartUtils';
import { ChartAvailablePeriods, PeriodDesc, Periods, TFInfo, TradeAnalysisType } from '@shared/utils/History/TFInfo';
import { SessionInfo } from '@shared/utils/History/SessionInfo';
import { DynProperty, DynPropertyRelationType } from '@shared/commons/DynProperty';
import { Enum } from '@shared/utils/Enum';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraChartMVCModel {
    constructor(dataCache) {
        this.CurrentAllowedStyles = [];
        this.CurrentAllowedPeriods = [];
        /// <summary>
        /// readonly!! use SelectHistoryPeriod(lastPeriodDesc); to set data
        /// </summary>
        this.CurrentTFTypeSelectedStyle = {}; // new Dictionary<string, TerceraChartDrawingType>();
        this.ModelItemChanged = new CustomEvent();
        this.refreshChart = new CustomEvent();
        this.skipRefreshChartInCallback = false;
        this.showAllSessions = true;
        this.timeFrameInfo = new TFInfo();
        this.chartDrawingType = TerceraChartDrawingType.Candle;
        this.chartHistoryType = ChartHistoryType.Default;
        this.showZeroes = false;
        this.DataCache = dataCache;
    }
    /// <summary>
    /// Активный инструмент
    /// </summary>
    SetInstrument(value) {
        this.prevInstrument = this.instrument;
        this.instrument = value;
        // http://tp.pfsoft.net/entity/57686
        if (this.chartHistoryType === ChartHistoryType.Default) {
            if (!isNullOrUndefined(this.instrument) && !isNullOrUndefined(this.timeFrameInfo)) {
                this.timeFrameInfo.HistoryType = this.instrument.DefaultChartHistoryType;
            }
        }
        this.UpdateTFRelation();
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.Instrument));
    }
    GetInstrument() {
        if (this.instrument) {
            return this.instrument;
        }
        else {
            return null;
        }
    }
    /// // <summary>
    /// // #42695
    /// // чтобы при измении настроек ChartDrawingType через другие контролы при открытом окне PropertiesScreen не применялись настройки из PropertiesScreen, потом при сохранении
    /// // </summary>
    // int? remeberChartDrawingType = null;
    /// <summary>
    /// Активный аккаунт
    /// </summary>
    SetAccount(value) {
        this.account = value;
        this.UpdateTFRelation();
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.Account));
    }
    GetAccount() {
        return this.account;
    }
    /// <summary>
    /// TODO: обновлять на смену всего что влияет: инструмент/аккаунт/historyType/...
    /// </summary>
    SetTimeFrameInfo(value) {
        /// tmp
        let periodWasChanged = false;
        if (this.timeFrameInfo && value && value.Periods !== this.timeFrameInfo.Periods) {
            periodWasChanged = true;
        }
        //    // refresh chart when timeFrameInfo changed: timeFrameInfo, Plan, HistoryType,
        //    if (value != null && (value != timeFrameInfo || ((instrument != null && account != null) && (timeFrameInfo.Plan != account.SpreadPlan || timeFrameInfo.HistoryType != instrument.HistoryType || timeFrameInfo.SessionInfo.OnlyMainSession == ShowAllSessions))))
        // {
        //        if ((!BaseApplication.App.MultiDataCache.isAllowedForMyUser(RulesSet.FUNCTION_CHART_CLUSTER) && value.TradeAnalysisType == TradeAnalysisType.Cluster) ||
        //       (!BaseApplication.App.MultiDataCache.isAllowedForMyUser(RulesSet.FUNCTION_CHART_MARKET_PROFILE) && value.TradeAnalysisType == TradeAnalysisType.MarketProfile))
        //            return;
        //        var needToSetDefaultHistoryType = timeFrameInfo != null && timeFrameInfo.TradeAnalysisType == TradeAnalysisType.Cluster;
        //        var spreadPlan = value.Plan;
        //        if (account != null)
        //            spreadPlan = account.SpreadPlan;
        //        else if (BaseApplication.App.Settings != null)
        //            spreadPlan = BaseApplication.App.Settings.SpreadPlan;
        //        if (instrument != null)
        //            // todo !!!! HistoryType
        //            timeFrameInfo = value.Copy(TerceraChartHistoryType.GetOriginalHistoryType(chartHistoryType, instrument), spreadPlan, new SessionInfo(!showAllSessions));
        //        else
        //            timeFrameInfo = value;
        //        //
        this.timeFrameInfo = value;
        this.timeFrameInfo.Plan = this.DataCache.GetSpreadPlan(this.account);
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.TFI));
        //        //
        this.UpdateStylesRelation();
        this.UpdateHistoryTypeRelation();
        //        // For cluster chart - only by trades (last) is allowed.
        //        if (timeFrameInfo.TradeAnalysisType == TradeAnalysisType.Cluster)
        //        {
        //            if (ChartHistoryType != TerceraChartHistoryTypeEnum.ByTrades)
        //                ChartHistoryType = TerceraChartHistoryTypeEnum.ByTrades;
        //        }
        //        else if(needToSetDefaultHistoryType)
        //        {
        //            ChartHistoryType = TerceraChartHistoryTypeEnum.Default;
        //        }
        // }
        //    // всегда фром дейт
        this.UpdateRangeRelation(periodWasChanged);
    }
    GetTimeFrameInfo() {
        return this.timeFrameInfo;
    }
    UpdateTFRelation() {
        if (this.instrument == null) {
            return;
        }
        if (!isNullOrUndefined(this.timeFrameInfo.SessionInfo)) {
            this.timeFrameInfo.SessionInfo.OnlyMainSession = !this.showAllSessions;
        }
        this.SetTimeFrameInfo(this.timeFrameInfo); // update if need
    }
    SetChartDrawingType(value) {
        this.chartDrawingType = value;
        // save selected style
        const key = this.GetTFTypeKey(this.timeFrameInfo);
        if (key != null) {
            this.CurrentTFTypeSelectedStyle[key] = this.chartDrawingType;
        }
        this.UpdateStylesRelation();
    }
    GetChartDrawingType() {
        return this.chartDrawingType;
    }
    GetAllowedStyles(currentSelection) {
        if (!currentSelection) {
            return [];
        }
        const result = [];
        switch (currentSelection.ChartDataType) {
            case ChartDataType.Default:
                // Cluster.
                if (currentSelection.TradeAnalysisType() === TradeAnalysisType.Cluster) {
                    result.push(TerceraChartDrawingType.Cluster);
                }
                // Market profile.
                else if (currentSelection.TradeAnalysisType() === TradeAnalysisType.MarketProfile) {
                    result.push(TerceraChartDrawingType.Profile);
                }
                else if (currentSelection.Periods === 0) // 1 Tick
                 {
                    result.push(TerceraChartDrawingType.Line);
                }
                else if (currentSelection.Periods % Periods.RANGE === 0) // Range
                 {
                    result.push(TerceraChartDrawingType.Line);
                    result.push(TerceraChartDrawingType.Bar);
                    result.push(TerceraChartDrawingType.Candle);
                    result.push(TerceraChartDrawingType.Dot);
                    result.push(TerceraChartDrawingType.DotLine);
                    result.push(TerceraChartDrawingType.Forest);
                    result.push(TerceraChartDrawingType.Solid);
                }
                else {
                    result.push(TerceraChartDrawingType.Line);
                    result.push(TerceraChartDrawingType.Bar);
                    result.push(TerceraChartDrawingType.Candle);
                    result.push(TerceraChartDrawingType.Dot);
                    result.push(TerceraChartDrawingType.DotLine);
                    result.push(TerceraChartDrawingType.Forest);
                    result.push(TerceraChartDrawingType.Solid);
                }
                break;
            case ChartDataType.Renco:
                result.push(TerceraChartDrawingType.Renko);
                result.push(TerceraChartDrawingType.Line);
                result.push(TerceraChartDrawingType.Dot);
                result.push(TerceraChartDrawingType.DotLine);
                result.push(TerceraChartDrawingType.Forest);
                result.push(TerceraChartDrawingType.Solid);
                break;
            case ChartDataType.Kagi:
                result.push(TerceraChartDrawingType.Kagi);
                break;
            case ChartDataType.ThreeLinesBreak:
                result.push(TerceraChartDrawingType.LinesBreak);
                result.push(TerceraChartDrawingType.Line);
                result.push(TerceraChartDrawingType.Dot);
                result.push(TerceraChartDrawingType.DotLine);
                result.push(TerceraChartDrawingType.Forest);
                result.push(TerceraChartDrawingType.Solid);
                break;
            case ChartDataType.TicTac:
                result.push(TerceraChartDrawingType.TicTac);
                result.push(TerceraChartDrawingType.Candle);
                break;
            // case ChartDataType.Volume:
            default:
                result.push(TerceraChartDrawingType.Candle);
                break;
        }
        // TODO. Refactor.
        const filteredResult = [];
        const len = result.length;
        for (let i = 0; i < len; i++) {
            const style = result[i];
            const locKey = TerceraChartUtils.getChartDrawingTypeLocKey(style);
            if (Resources.isHidden(locKey))
                continue;
            filteredResult.push(style);
        }
        return filteredResult;
    }
    UpdateStylesRelation() {
        const currentSelection = this.timeFrameInfo;
        const CurrentAllowedStyles = this.GetAllowedStyles(currentSelection);
        this.CurrentAllowedStyles = CurrentAllowedStyles;
        const CurrentTFTypeSelectedStyle = this.CurrentTFTypeSelectedStyle;
        // restore selected style
        const key = this.GetTFTypeKey(currentSelection);
        const currentTFTypeSelectedStyleItem = CurrentTFTypeSelectedStyle[key];
        if (CurrentAllowedStyles.includes(currentTFTypeSelectedStyleItem)) {
            this.chartDrawingType = currentTFTypeSelectedStyleItem;
        }
        else if (CurrentAllowedStyles.includes(TerceraChartDrawingType.Candle) &&
            currentSelection.ChartDataType !== ChartDataType.TicTac) {
            this.chartDrawingType = TerceraChartDrawingType.Candle;
        }
        else {
            this.chartDrawingType = CurrentAllowedStyles[0];
        }
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.Style));
    }
    UpdateHistoryTypeRelation() {
        const timeFrameInfo = this.GetTimeFrameInfo();
        const period = timeFrameInfo.Periods;
        const lSourceTypes = this.DataCache.GetAllowedHistoryTypesByPeriod(period);
        let ok = false;
        const historyType = this.GetChartHistoryType();
        switch (historyType) {
            case ChartHistoryType.Default:
                ok = true;
                break;
            case ChartHistoryType.ByBid:
                ok = lSourceTypes.Contains(timeFrameInfo.HistoryType) && period !== Periods.TIC;
                break;
            case ChartHistoryType.ByBidAsk:
                ok = lSourceTypes.Contains(timeFrameInfo.HistoryType) && period === Periods.TIC;
                break;
            default:
                ok = lSourceTypes.Contains(timeFrameInfo.HistoryType);
                break;
        }
        if (!ok) {
            this.SetChartHistoryType(ChartHistoryType.Default);
        }
    }
    GetTFTypeKey(currentSelection) {
        let keyToSaveSelectedStyle = null;
        if (currentSelection != null) {
            switch (currentSelection.ChartDataType) {
                case ChartDataType.Default:
                    if (currentSelection.Periods === 0) // 1 Tick
                     {
                        keyToSaveSelectedStyle = '1Tick';
                    }
                    else if (currentSelection.Periods % Periods.RANGE === 0) // Range
                     {
                        keyToSaveSelectedStyle = 'Range';
                    }
                    else {
                        keyToSaveSelectedStyle = 'Time';
                    }
                    break;
                case ChartDataType.Renco:
                case ChartDataType.Kagi:
                case ChartDataType.ThreeLinesBreak:
                case ChartDataType.TicTac:
                // case ChartDataType.Volume:
                default:
                    keyToSaveSelectedStyle = currentSelection.ChartDataType.toString();
                    break;
            }
        }
        return keyToSaveSelectedStyle;
    }
    GetPeriodDesc() {
        return this.lastPeriodDesc;
    }
    SetPeriodDesc(value) {
        if (this.lastPeriodDesc != value) {
            this.lastPeriodDesc = value;
            this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.Range));
        }
    }
    UpdateRangeRelation(resetToDefault /* = false */) {
        if (!this.timeFrameInfo) {
            return;
        }
        const CurrentAllowedPeriods = ChartAvailablePeriods.GetAvaialbleCounts(this.timeFrameInfo.Periods);
        this.CurrentAllowedPeriods = CurrentAllowedPeriods;
        let containCurrentPeriodDesc = false;
        const len = CurrentAllowedPeriods.length;
        const lastPeriodDesc = this.GetPeriodDesc();
        for (let i = 0; i < len; i++) {
            if (lastPeriodDesc === null || lastPeriodDesc === void 0 ? void 0 : lastPeriodDesc.equals(this.CurrentAllowedPeriods[i])) {
                containCurrentPeriodDesc = true;
                break;
            }
        }
        // Current value of PeriodDesc is inccorect for current TifeFrameInfo
        if (resetToDefault || !containCurrentPeriodDesc) {
            this.SetPeriodDesc(ChartAvailablePeriods.GetDefaultValueOfPeriod(this.timeFrameInfo.Periods));
        }
        // Check whether default PeriodDesc contains in CurrentAllowedPeriods ???
        //
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.Range));
    }
    /// <summary>
    /// History type
    /// </summary>
    GetChartHistoryType() {
        return this.chartHistoryType;
    }
    SetChartHistoryType(value) {
        this.chartHistoryType = value;
        const timeFrameInfo = this.GetTimeFrameInfo();
        if (timeFrameInfo) {
            if (!timeFrameInfo.SessionInfo) // https://tp.traderevolution.com/entity/103886 из callback приходил TFInfo не содержащий SessionInfo и переписывающий тот в котором SessionInfo было
             {
                timeFrameInfo.SessionInfo = new SessionInfo(!this.GetShowAllSessions());
            }
            this.SetTimeFrameInfo(timeFrameInfo.Copy({
                period: timeFrameInfo.Periods,
                historyType: TerceraChartHistoryType.GetOriginalHistoryType(this.chartHistoryType, this.instrument)
            }));
        }
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.HistoryType));
    }
    /// <summary>
    /// Учитывать дырки при индексации
    /// </summary>
    GetShowZeroes() {
        return this.showZeroes;
    }
    SetShowZeroes(value) {
        this.showZeroes = value;
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.ShowEmptyBars));
    }
    GetShowAllSessions() {
        return this.showAllSessions;
    }
    SetShowAllSessions(value) {
        this.showAllSessions = value;
        this.UpdateTFRelation();
        this.OnModelItemChanged(new TerceraChartMVCModelItem(ModelDataType.ShowAllSession));
    }
    Dispose() {
        this.account = null;
        this.instrument = null;
        this.prevInstrument = null;
    }
    OnModelItemChanged(item) {
        this.ModelItemChanged.Raise(item);
    }
    // #region ICaller
    Properties() {
        const properties = [];
        let prop = null;
        const timeFrameInfo = this.GetTimeFrameInfo();
        const chartDrawingType = this.GetChartDrawingType();
        const chartHistoryType = this.GetChartHistoryType();
        const instrument = this.GetInstrument();
        if (timeFrameInfo) {
            const tradeAnalysisType = timeFrameInfo.TradeAnalysisType();
            if (tradeAnalysisType !== TradeAnalysisType.Cluster) {
                if (tradeAnalysisType !== TradeAnalysisType.MarketProfile) {
                    prop = new DynProperty('gr_type', chartDrawingType, DynProperty.COMBOBOX, DynProperty.DATA_STYLE_GROUP);
                    const objVariants = [];
                    const allowedStyles = this.GetAllowedStyles(timeFrameInfo);
                    const allowedStyles_len = allowedStyles.length;
                    for (let i = 0; i < allowedStyles_len; i++) {
                        const allowedStyle = allowedStyles[i];
                        objVariants.push({
                            type: NewContextMenuItemType.Default,
                            text: TerceraChartUtils.ToLocalizedTerceraChartDrawingType(allowedStyle),
                            value: allowedStyle
                        });
                    }
                    prop.objectVariants = objVariants;
                    prop.assignedProperty = [
                        'bodyColor',
                        'borderColor',
                        'wickColor',
                        'barsHiLowColor',
                        'solidPriceColor',
                        'HistogramLineColor',
                        'Doji'
                    ];
                    prop.DynPropertyRelationType = DynPropertyRelationType.Visibility;
                    prop.COMBOBOX_TYPE = DynProperty.INTEGER;
                    prop.sortIndex = 0;
                    properties.push(prop);
                }
                prop = new DynProperty('HistoryType', chartHistoryType, DynProperty.COMBOBOX, DynProperty.DATA_STYLE_GROUP);
                const historyTypeArray = [];
                if (timeFrameInfo) {
                    const dataTypes_keys = Enum.TakeKeysFromEnum(ChartHistoryType);
                    const dataTypes_keys_len = dataTypes_keys.length;
                    for (let i = 0; i < dataTypes_keys_len; i++) {
                        const dt = ChartHistoryType[dataTypes_keys[i]];
                        const state = TerceraChartActionState.GetHistoryTypeActionState(new TerceraChartHistoryType(dt), timeFrameInfo.Periods, instrument, chartHistoryType);
                        if (state.Visible) {
                            historyTypeArray.push({
                                type: NewContextMenuItemType.Default,
                                text: Resources.getResource(state.locKey),
                                value: dt
                            });
                        }
                    }
                }
                prop.objectVariants = historyTypeArray;
                prop.sortIndex = 1;
                properties.push(prop);
            }
        }
        // Show
        const SeparatorGroup = '#2#' + Resources.getResource('property.SeparatorGroup.Show');
        prop = new DynProperty('ShowEmptyBars', this.GetShowZeroes(), DynProperty.BOOLEAN, DynProperty.TIME_SCALE_GROUP);
        prop.separatorGroup = SeparatorGroup;
        prop.sortIndex = 1;
        properties.push(prop);
        prop = new DynProperty('showAllSessions', this.GetShowAllSessions(), DynProperty.BOOLEAN, DynProperty.TIME_SCALE_GROUP);
        prop.separatorGroup = SeparatorGroup;
        prop.sortIndex = 2;
        properties.push(prop);
        // TFI
        if (timeFrameInfo) {
            prop = new DynProperty('timeFrameInfo', timeFrameInfo.Serialize(), DynProperty.STRING, DynProperty.HIDDEN_GROUP);
            prop.sortIndex = 2;
            properties.push(prop);
        }
        // PeriodDesc
        const lastPeriodDesc = this.GetPeriodDesc();
        if (lastPeriodDesc) {
            properties.push(new DynProperty('HistoryPeriod', lastPeriodDesc.Period, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
            properties.push(new DynProperty('HistoryKoef', lastPeriodDesc.Koef, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        }
        return properties;
    }
    callBack(properties) {
        let needRecreateCacheItem = false;
        // TFI
        let dp = DynProperty.getPropertyByName(properties, 'timeFrameInfo');
        if (dp && typeof dp.value === 'string') {
            this.SetTimeFrameInfo(TFInfo.Parse(dp.value));
        }
        // from model
        dp = DynProperty.getPropertyByName(properties, 'HistoryType');
        // + проверяет что изменилось чтоб зря не перегружать чарт
        if (dp && this.GetChartHistoryType() !== dp.value) {
            this.SetChartHistoryType(dp.value);
            needRecreateCacheItem = true;
        }
        const chartHistoryType = TerceraChartHistoryType.GetOriginalHistoryType(this.chartHistoryType, this.instrument);
        if (chartHistoryType !== this.timeFrameInfo.HistoryType) {
            this.SetChartHistoryType(this.chartHistoryType);
        }
        dp = DynProperty.getPropertyByName(properties, 'showAllSessions');
        // + проверяет что изменилось чтоб зря не перегружать чарт
        if (dp && this.GetShowAllSessions() !== dp.value) {
            this.SetShowAllSessions(dp.value);
            needRecreateCacheItem = true;
        }
        // + проверяет что изменилось чтоб зря не перегружать чарт
        dp = DynProperty.getPropertyByName(properties, 'ShowEmptyBars');
        if (dp && this.GetShowZeroes() !== dp.value) {
            this.SetShowZeroes(dp.value);
            needRecreateCacheItem = true;
        }
        // PeriodDesc
        let historyPeriod = -1;
        let historyKoef = -1;
        dp = DynProperty.getPropertyByName(properties, 'HistoryPeriod');
        if (dp)
            historyPeriod = dp.value;
        dp = DynProperty.getPropertyByName(properties, 'HistoryKoef');
        if (dp)
            historyKoef = dp.value;
        if (historyPeriod >= 0 && historyKoef >= 0) {
            this.SetPeriodDesc(new PeriodDesc(historyKoef, historyPeriod));
        }
        dp = DynProperty.getPropertyByName(properties, 'gr_type');
        if (dp)
            this.SetChartDrawingType(dp.value);
        // + проверяет что изменилось чтоб зря не перегружать чарт
        if (needRecreateCacheItem && !this.skipRefreshChartInCallback) {
            this.refreshChart.Raise();
        }
    }
}
export class TerceraChartMVCModelItem {
    constructor(type) {
        this.ItemType = type;
    }
}
export var ModelDataType;
(function (ModelDataType) {
    ModelDataType[ModelDataType["TFI"] = 0] = "TFI";
    ModelDataType[ModelDataType["Range"] = 1] = "Range";
    ModelDataType[ModelDataType["Style"] = 2] = "Style";
    ModelDataType[ModelDataType["Instrument"] = 3] = "Instrument";
    ModelDataType[ModelDataType["Account"] = 4] = "Account";
    ModelDataType[ModelDataType["HistoryType"] = 5] = "HistoryType";
    ModelDataType[ModelDataType["ShowAllSession"] = 6] = "ShowAllSession";
    ModelDataType[ModelDataType["ShowEmptyBars"] = 7] = "ShowEmptyBars";
})(ModelDataType || (ModelDataType = {}));
export var ChartLoadTrigger;
(function (ChartLoadTrigger) {
    ChartLoadTrigger[ChartLoadTrigger["ScrollingLeft"] = 0] = "ScrollingLeft";
    ChartLoadTrigger[ChartLoadTrigger["RefreshAction"] = 1] = "RefreshAction";
    ChartLoadTrigger[ChartLoadTrigger["LoadingPeriodChanged"] = 2] = "LoadingPeriodChanged";
    ChartLoadTrigger[ChartLoadTrigger["FirstLoadingByPeriod"] = 3] = "FirstLoadingByPeriod";
    ChartLoadTrigger[ChartLoadTrigger["LoadingRelativelyMidDate"] = 4] = "LoadingRelativelyMidDate";
    ChartLoadTrigger[ChartLoadTrigger["ScrollingRight"] = 5] = "ScrollingRight";
})(ChartLoadTrigger || (ChartLoadTrigger = {}));
// #region Controller
export class TerceraChartMVCController {
    constructor(chart) {
        this.ActiveCommand = null;
        this.SuspendRefreshChart = false;
        this.terceraChart = chart;
    }
    ExecuteCommand(command, value) {
        if (this.ActiveCommand)
            return;
        try {
            this.ActiveCommand = command;
            this.ExecuteCommandInner(command, value);
            const isRefreshChart = command.NeedRefreshChart();
            if (isRefreshChart && !this.SuspendRefreshChart) {
                this.terceraChart.RefreshChart(command.GetTrigger());
            }
        }
        finally {
            this.ActiveCommand = null;
        }
    }
    Dispose() {
        this.terceraChart = null;
    }
    ExecuteCommandInner(command, value) {
        var _a;
        const terceraChart = this.terceraChart;
        switch (command.ModelItem.ItemType) {
            case ModelDataType.Instrument:
                terceraChart.model.SetInstrument(value);
                break;
            case ModelDataType.Account:
                terceraChart.model.SetAccount(value);
                break;
            case ModelDataType.TFI:
                terceraChart.model.SetTimeFrameInfo(value);
                break;
            case ModelDataType.Style:
                terceraChart.model.SetChartDrawingType(value);
                break;
            case ModelDataType.Range:
                terceraChart.model.SetPeriodDesc(value);
                break;
            case ModelDataType.ShowAllSession:
                terceraChart.model.SetShowAllSessions(value);
                break;
            case ModelDataType.ShowEmptyBars: {
                terceraChart.model.SetShowZeroes(value);
                // Перезагрузка не нужна, достаточно пересчитать индексы
                (_a = terceraChart.MainCashItemSeries) === null || _a === void 0 ? void 0 : _a.RecalcIndices();
                // забыли оверлеи
                const len = terceraChart.Overlays.length;
                for (let i = 0; i < len; i++) {
                    const ser = terceraChart.Overlays[i].mainPriceRenderer.Series;
                    if (ser)
                        ser.RecalcIndices();
                }
                break;
            }
            case ModelDataType.HistoryType:
                terceraChart.model.SetChartHistoryType(value);
                break;
        }
    }
}
// #endregion
// #region TerceraChartMVCCommand
export class TerceraChartMVCCommand {
    constructor(itemType) {
        this.ModelItem = new TerceraChartMVCModelItem(itemType);
    }
    NeedRefreshChart() {
        switch (this.ModelItem.ItemType) {
            case ModelDataType.Account:
            case ModelDataType.Instrument:
            case ModelDataType.TFI:
            case ModelDataType.Range:
            case ModelDataType.ShowAllSession:
            case ModelDataType.ShowEmptyBars:
            case ModelDataType.HistoryType:
                return true;
        }
        return false;
    }
    GetTrigger() {
        switch (this.ModelItem.ItemType) {
            case ModelDataType.Account:
            case ModelDataType.Instrument:
                return ChartLoadTrigger.RefreshAction;
        }
        return ChartLoadTrigger.RefreshAction;
    }
}
// #endregion
